import { useState, useRef } from 'react';
import Select from 'react-select';

const ASE_BLUE = '#298399';

const selectStyles = {
  control: (base, state) => ({
    ...base,
    borderColor: ASE_BLUE,
    borderRadius: '0.375rem',
    fontSize: '0.875rem',
    boxShadow: state.isFocused ? `0 0 0 1px ${ASE_BLUE}` : 'none',
    '&:hover': { borderColor: ASE_BLUE },
  }),
  option: (base, state) => ({
    ...base,
    fontSize: '0.875rem',
    backgroundColor: state.isSelected ? ASE_BLUE : state.isFocused ? '#e0f2f7' : 'white',
    color: state.isSelected ? 'white' : '#374151',
  }),
};

const inputClass = 'border border-ase-blue rounded-md px-3 py-2 text-sm flex-1 min-w-0 outline-none focus:ring-1 focus:ring-ase-blue bg-white';
const btnClass = 'border border-ase-blue text-ase-blue rounded-md px-3 text-sm font-bold hover:bg-ase-blue hover:text-white transition-colors shrink-0';

const CategoryPicker = ({ value, onChange, options = [], isLoading = false }) => {
  const [isAdding, setIsAdding] = useState(false);
  const prevValueRef = useRef('');

  const selectedOption = value ? { value, label: value } : null;

  const handleAddClick = () => {
    prevValueRef.current = value;
    onChange('');
    setIsAdding(true);
  };

  const handleCancel = () => {
    onChange(prevValueRef.current);
    setIsAdding(false);
  };

  if (isAdding) {
    return (
      <div className="flex gap-2">
        <input
          type="text"
          autoFocus
          className={inputClass}
          value={value}
          onChange={e => onChange(e.target.value)}
          placeholder="New category name..."
        />
        <button type="button" onClick={handleCancel} className={btnClass} title="Cancel">
          ×
        </button>
      </div>
    );
  }

  return (
    <div className="flex gap-2">
      <div className="flex-1 min-w-0">
        <Select
          options={options}
          value={selectedOption}
          onChange={selected => onChange(selected?.value || '')}
          styles={selectStyles}
          placeholder="— Select category —"
          isClearable
          isLoading={isLoading}
        />
      </div>
      <button type="button" onClick={handleAddClick} className={btnClass} title="Add new category">
        +
      </button>
    </div>
  );
};

export default CategoryPicker;
